export const getImg = (img) => {
    return process.env.VUE_APP_BASE_API + "/file/" + img;
};